<template>
	<p class="my-3">
		<a :href="item.url" target="_blank">{{ item.title }}</a>
	</p>
</template>
<script lang="ts">
import {defineComponent, PropType} from 'vue'

export default defineComponent({
	name: "InlineDocument",
	props: {
		item: {
			type: Object as PropType<any>,
			required: true
		}
	}
})
</script>
<style scoped>

</style>
